import { render, staticRenderFns } from "./YourAddress.vue?vue&type=template&id=40009d28&scoped=true&"
import script from "./YourAddress.vue?vue&type=script&lang=js&"
export * from "./YourAddress.vue?vue&type=script&lang=js&"
import style0 from "./YourAddress.vue?vue&type=style&index=0&id=40009d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40009d28",
  null
  
)

export default component.exports